import React, { FC } from "react";

import { List, ListItem, ListIcon } from "@UI/Components/List/List";
import { Box } from "@UI/Components/Box/Box";
import { Check } from "@UI/Components/Icons/Check";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";

import messages from "./messages";

export const SubscriptionAdvantagesList: FC = () => {
  return (
    <List spacing="1">
      {Object.keys(messages).map((advantage, index) => (
        <ListItem key={`advantage-${index}`} display="flex" alignItems="start">
          <ListIcon as={Check} color="green.500" marginTop="xs" />
          <Box marginLeft="2">
            <FormattedMessage {...messages[advantage]} />
          </Box>
        </ListItem>
      ))}
    </List>
  );
};
